import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { datapoints } from '../datapoints';
import { FolderBreadcrumb } from '../store/schema/FolderBreadcrumb';
import { FolderModel } from '../store/schema/FolderModel';
import { FolderSelectorError } from '../store/schema/FolderSelectorError';

/**
 * Folder selector modal actions
 */
export const openFolderSelector = action('openFolderSelector', () =>
    addDatapointConfig(datapoints.FPFolderSelectorOpened)
);

export const closeFolderSelector = action('closeFolderSelector', () => ({}));

/**
 * Breadcrumbs related actions
 */
export const breadcrumbSelected = action('breadcrumbSelected', (breadcrumb: FolderBreadcrumb) => ({
    breadcrumb,
}));

export const clearAllBreadcrumbsUpTill = action(
    'clearAllBreadcrumbsUpTill',
    (folderId?: string) => ({ folderId })
);

export const clearAllBreadcrumbs = action('clearAllBreadcrumbs');

export const addBreadcrumb = action('addBreadcrumb', (breadcrumb: FolderBreadcrumb) => ({
    breadcrumb,
}));

/**
 * Folder selection related actions
 */
export const folderSelected = action('folderSelected', (folderId: string) => ({
    folderId,
}));

/**
 * This will load the folders. Not providing `folderId` will load the root folder.
 */
export const loadFolders = action('loadFolders', (folderId?: string) => ({
    folderId,
}));

export const reloadFolders = action('reloadFolders');

export const foldersLoaded = action('foldersLoaded', (folders: FolderModel[]) => ({
    folders,
}));

export const loadingFoldersFailed = action(
    'loadingFoldersFailed',
    (error: FolderSelectorError.UnableToOpenFolder) => ({ error })
);

export const loadingFileProvidersFailed = action('loadingFileProvidersFailed');

/**
 * Create folder related actions
 */
export const createNewFolder = action('createNewFolder', (folderName: string) => ({ folderName }));

export const creatingNewFolder = action('creatingNewFolder', (folderName: string) => ({
    folderName,
}));
export const createdNewFolder = action('createdNewFolder', (folder: FolderModel) => ({
    folder,
}));
export const creatingNewFolderFailed = action(
    'creatingNewFolderFailed',
    (error: FolderSelectorError.CreatingNewFolder | FolderSelectorError.FolderAlreadyExists) => ({
        error,
    })
);

export const userEnteringNewFolderName = action(
    'userEnteringNewFolderName',
    (isUserEnteringNewFolderName: boolean) => ({ isUserEnteringNewFolderName })
);

/**
 * Bottom loading spinner related actions
 */
export const loading = action('loading');
export const stoppedLoading = action('stoppedLoading');
